import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Airport, AirportType } from '../models/airport.model';
import { CommentType } from '../models/airport-comment.model';
import { LandingSurfaceType } from '../models/landing-surface.model';
import { PilotControlledLighting } from '../models/pilot-controlled-lighting.model';
import { PatternAltitude } from '../models/pattern-altitude.model';
import { Source } from '../../shared/models/source.model';
import { getSubTags } from '../../util/tag-utils';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditPatternAltitudeComponent } from '../edit-pattern-altitude/edit-pattern-altitude.component';
import { EditPilotControlledLightingComponent } from '../edit-pilot-controlled-lighting/edit-pilot-controlled-lighting.component';
import { AirportService } from '../airport.service';
import { EditTagsComponent } from '../../shared/edit-tags/edit-tags.component';
import { DeletePatternAltitudeComponent } from '../delete-pattern-altitude/delete-pattern-altitude.component';
import { DeletePilotControlledLightingComponent } from '../delete-pilot-controlled-lighting/delete-pilot-controlled-lighting.component';
var OperationsComponent = /** @class */ (function () {
    function OperationsComponent(_toggleService, _snackBar, _editPatternAltitudeDialog, _deletePatternAltitudeDialog, _editPCLDialog, _deletePCLDialog, _airportService, _editSpecialOpsDialog) {
        this._toggleService = _toggleService;
        this._snackBar = _snackBar;
        this._editPatternAltitudeDialog = _editPatternAltitudeDialog;
        this._deletePatternAltitudeDialog = _deletePatternAltitudeDialog;
        this._editPCLDialog = _editPCLDialog;
        this._deletePCLDialog = _deletePCLDialog;
        this._airportService = _airportService;
        this._editSpecialOpsDialog = _editSpecialOpsDialog;
        this.getSubTags = getSubTags;
        this.Source = Source;
    }
    OperationsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
    };
    OperationsComponent.prototype.lightingIntensity = function (intensity) {
        return PilotControlledLighting.formatLightingIntensity(intensity);
    };
    OperationsComponent.prototype.formatAircraftClass = function (aircraftClass) {
        return PatternAltitude.formatAircraftClass(aircraftClass);
    };
    Object.defineProperty(OperationsComponent.prototype, "lightingRemarks", {
        get: function () {
            return this.airport.airportComments
                .filter(function (comment) { return comment.commentType === CommentType.Lighting; })
                .sort(function (n1, n2) { return n1.sourceId - n2.sourceId; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OperationsComponent.prototype, "patternAltRemarks", {
        get: function () {
            return this.airport.airportComments
                .filter(function (comment) { return comment.commentType === CommentType.PatternAlt; })
                .sort(function (n1, n2) { return n1.sourceId - n2.sourceId; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OperationsComponent.prototype, "pilotControlledLighting", {
        get: function () {
            return this.airport.pilotControlledLighting
                .sort(function (n1, n2) { return n1.intensity - n2.intensity; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OperationsComponent.prototype, "patternAltitudes", {
        get: function () {
            return this.airport.patternAltitudes
                .sort(function (n1, n2) { return n1.altitude - n2.altitude; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OperationsComponent.prototype, "windIndicator", {
        get: function () {
            if (this.airport.windIndicator && this.airport.windIndicatorLighted) {
                return 'Lighted';
            }
            return this.airport.windIndicator ? 'Yes' : 'No';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OperationsComponent.prototype, "segmentedCircle", {
        get: function () {
            if (this.airport.segmentedCircle && this.airport.segmentedCircleLighted) {
                return 'Lighted';
            }
            return this.airport.segmentedCircle ? 'Yes' : 'No';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OperationsComponent.prototype, "beacon", {
        get: function () {
            var beaconInfo;
            if (this.airport.beacon) {
                beaconInfo = 'Present';
                if (this.airport.beaconColor != null && this.airport.beaconColor.length > 0) {
                    beaconInfo = beaconInfo + ' (' + this.airport.beaconColor + ')';
                }
                return beaconInfo;
            }
            return 'Not Present';
        },
        enumerable: true,
        configurable: true
    });
    OperationsComponent.prototype.reloadAirport = function (identifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(identifier, true)];
                    case 1:
                        _a.airport = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(OperationsComponent.prototype, "airportSpecialOps", {
        get: function () {
            var specOps = [];
            /* if (hasTag(this.airport.airportTags, 'Operations::Glider Ops')) {
              specOps.push('Glider Ops');
            }
            if (this.airport.type !== AirportType.Heliport && (hasTag(this.airport.airportTags, 'Operations::Helicopter Ops')
                || this.airport.hasLandingSurfaceType(LandingSurfaceType.Helipad))) {
              specOps.push('Helicopter Ops');
            }
            if (this.airport.type !== AirportType.SeaplaneBase &&
              this.airport.hasLandingSurfaceType(LandingSurfaceType.Waterway)) {
              specOps.push('Seaplane Ops');
            }
            if (hasTag(this.airport.airportTags, 'Operations::Ultralight Ops')) {
              specOps.push('Ultralight Ops');
            }
            if (specOps.length === 0) {
              return 'None reported';
            } */
            if (this.airport.type !== AirportType.Heliport && this.airport.hasLandingSurfaceType(LandingSurfaceType.Helipad)) {
                specOps.push('Helicopter Ops');
            }
            if (this.airport.type !== AirportType.SeaplaneBase && this.airport.hasLandingSurfaceType(LandingSurfaceType.Waterway)) {
                specOps.push('Seaplane Ops');
            }
            if (specOps.length === 0) {
                return '';
            }
            return specOps.join(', ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OperationsComponent.prototype, "airportSpecialOpsAirportManager", {
        get: function () {
            var result = [];
            for (var _i = 0, _a = this.airport.airportTags; _i < _a.length; _i++) {
                var currentTag = _a[_i];
                if (currentTag.tagName.startsWith('Operations::')) {
                    if (currentTag.tagName !== 'Operations::Glider Ops' && currentTag.tagName !== 'Operations::Helicopter Ops'
                        && currentTag.tagName !== 'Operations::Ultralight Ops' && currentTag.tagName !== 'Operations::Commercial Ops') {
                        result.push(currentTag.displayName);
                    }
                }
            }
            return result.sort().join(', ');
        },
        enumerable: true,
        configurable: true
    });
    OperationsComponent.prototype.openEditPatternAltDialog = function (index) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '60%';
        dialogConfig.data = {
            airportId: this.airport.airportId,
            patternAltId: null,
            isNew: false,
            patternAltitudes: this.airport.patternAltitudes
        };
        index == null ? dialogConfig.data.isNew = true : dialogConfig.data.patternAlt = this.airport.patternAltitudes[index];
        dialogConfig.data['airID'] = this.airport.airportId;
        dialogConfig.width = '60%';
        var dialogRef = this._editPatternAltitudeDialog.open(EditPatternAltitudeComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                if (isUpdated.isNew) {
                    _this.airport.patternAltitudes.push(isUpdated.patternAlt);
                    _this._snackBar.open('Pattern Altitude', 'Added', {
                        duration: 2000
                    });
                }
                else {
                    _this._snackBar.open('Pattern Altitude', 'Updated', {
                        duration: 2000
                    });
                }
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    OperationsComponent.prototype.deletePatternAlt = function (index) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            airportId: this.airport.airportId,
            patternAltId: this.airport.patternAltitudes[index].patternAltId
        };
        var dialogRef = this._deletePatternAltitudeDialog.open(DeletePatternAltitudeComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this._snackBar.open('Pattern Altitude', 'Deleted', {
                    duration: 2000
                });
                _this.airport.patternAltitudes.splice(index, 1);
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    OperationsComponent.prototype.openEditPCLDialog = function (index) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '60%';
        dialogConfig.data = {
            airID: this.airport.airportId,
            pclId: null,
            isNew: false,
            PCL: this.airport.pilotControlledLighting
        };
        index == null ? dialogConfig.data.isNew = true : dialogConfig.data.pcl = this.airport.pilotControlledLighting[index];
        dialogConfig.data['airID'] = this.airport.airportId;
        var dialogRef = this._editPCLDialog.open(EditPilotControlledLightingComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                if (isUpdated.isNew) {
                    // this.airport.pilotControlledLighting.push(isUpdated.pcl);
                    _this.reloadAirport(_this.airport.identifier);
                    _this._snackBar.open('Pilot Activated Lighting', 'Added', {
                        duration: 2000
                    });
                }
                else {
                    _this._snackBar.open('Pilot Activated Lighting', 'Updated', {
                        duration: 2000
                    });
                }
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    OperationsComponent.prototype.deletePCL = function (index) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            airportId: this.airport.airportId,
            pclId: this.airport.pilotControlledLighting[index].pclId
        };
        var dialogRef = this._deletePCLDialog.open(DeletePilotControlledLightingComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this._snackBar.open('Pilot Controlled Lighting', 'Deleted', {
                    duration: 2000
                });
                _this.airport.pilotControlledLighting.splice(index, 1);
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    OperationsComponent.prototype.openEditTagsDialog = function (group, except, title) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            business: this.airport,
            tagsGroup: group,
            except: except,
            title: title
        };
        dialogConfig.width = '100%';
        var dialogRef = this._editSpecialOpsDialog.open(EditTagsComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isSuccess) {
            if (isSuccess) {
                // this.loadAllTags();
                _this.reloadAirport(_this.airport.identifier);
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return OperationsComponent;
}());
export { OperationsComponent };
